import { combineReducers } from 'redux'
import ImporterReducer from './ImporterReducer'
import FormReducer from './FormReducer'
import BOLInfoReducer from './BOLInfoReducer'
import BondInfoReducer from './BondInfoReducer'
import DescriptionOfMerchandiseReducer from './DescriptionOfMerchandiseReducer'
import MerchandiseUIReducer from './MerchandiseUIReducer'
import EntryTypeReducer from './EntryTypeReducer'
import TransportInfoReducer from './TransportInfoReducer'
import ReconInfoReducer from './ReconInfoReducer'
// import LaceyActReducer from './LaceyActReducer'
import DropDownReducer from './DropDownReducer'
// import TSCAReducer from './TSCAReducer'
import DeclarationSectionReducer from './DeclarationSectionReducer'
import PscChainReducer from './PscChainReducer'
import FieldValidationReducer from './FieldValidationReducer'
import FDAReducer from './FDAReducer'
import FormValidationReducer from './FormValidationReducer'
import PSCReducer from './PSCReducer'
import NotesReducer from "./Notes.Reducer"

function createReducer(asyncReducers) {
  return combineReducers({
    Importer: ImporterReducer,
    EntryTypeInfo: EntryTypeReducer,
    BondInfo: BondInfoReducer,
    TransportationInfo: TransportInfoReducer,
    DescriptionOfMerchandise: DescriptionOfMerchandiseReducer,
    MerchandiseUI: MerchandiseUIReducer,
    BOLInfo: BOLInfoReducer,
    // LaceyAct: LaceyActReducer(''),
    DropDownValues: DropDownReducer,
    FormValues: FormReducer,
    // TSCA: TSCAReducer,
    PscChainRawResponse: PscChainReducer,
    DeclarationSection: DeclarationSectionReducer,
    FieldValidation: FieldValidationReducer,
    FormValidation: FormValidationReducer,
    FDA: FDAReducer,
    PSC: PSCReducer,
    NotesReducer:NotesReducer,
    ReconInfo: ReconInfoReducer,
    ...asyncReducers,
  });
}

// let rootReducer = combineReducers({
//   Importer: ImporterReducer,
//   EntryTypeInfo: EntryTypeReducer,
//   BondInfo: BondInfoReducer,
//   TransportationInfo: TransportInfoReducer,
//   DescriptionOfMerchandise: DescriptionOfMerchandiseReducer,
//   BOLInfo: BOLInfoReducer,
//   LaceyAct: LaceyActReducer,
//   DropDownValues: DropDownReducer,
//   FormValues: FormReducer,
//   TSCA: TSCAReducer,
//   DeclarationSection: DeclarationSectionReducer,
//   FieldValidation: FieldValidationReducer,
//   FDA: FDAReducer
// })

export {
  createReducer,
  // rootReducer
}
